<template>
    <b-row no-gutters>
        <b-col class="px-4 py-3">
            <h4 class="pb-2">
                Variable Product
            </h4>
            <section style="font-size: 13px;" class="products-with-variations" v-if="origin==='new_product'">
                <b-table
                    :items="values"
                    :fields="fields"
                    :empty-text="(loading) ? 'Loading data' : 'No product records found'"
                    class="w-100"
                    bordered>
                    <template slot="variation" slot-scope="data">
                        <div class="text-nowrap">
                            {{
                                origin == 'edit_product' && data.item.variation_code != null
                                    ? transformVariationName(data.item.variation_code)
                                    : data.value
                            }}
                        </div>
                    </template>
                    <template slot="stock" slot-scope="data">
                        <b-form-group
                            label-for="stock"
                            class="mb-0"
                            :invalid-feedback="errorMessage('product_variables.' + data.index + '.variable.stock')"
                            :state="isValid('product_variables.' + data.index + '.variable.stock')">
                            <b-form-input
                                type="number"
                                v-model="data.item.stock"
                                required min="0"
                                oninput="this.value = Math.abs(this.value)">
                            </b-form-input>
                        </b-form-group>
                    </template>
                    <template slot="regular_price" slot-scope="data">
                        <b-form-group
                            id="currencyGroup"
                            label-for="currency"
                            class="secondary-label mb-0"
                            :invalid-feedback="errorMessage('product_variables.' + data.index + '.variable.regular_price')"
                            :state="isValid('product_variables.' + data.index + '.variable.regular_price')">
                            <b-input-group>
                                <b-form-select slot="prepend"
                                    :options="options.currency"
                                    v-model="data.item.currency">
                                </b-form-select>
                                <b-form-input 
                                    id="regularPrice"
                                    v-model="data.item.regular_price"
                                    required
                                    type="number"
                                    :min="payment == 'CC' ? '1' : '0'"
                                    max="10000000000"
                                    @keyup.native="setDiscount({
                                        index: data.index,
                                        base: 'price'
                                    })"
                                />
                            </b-input-group>
                        </b-form-group>
                    </template>
                    <template slot="sku" slot-scope="data">
                        <div style="width: 140px;">
                            <b-form-group
                                id="skuGroup"
                                label-for="sku"
                                class="secondary-label mb-0"
                                :invalid-feedback="errorMessage('product_variables.' + data.index + '.variable.sku')"
                                :state="isValid('product_variables.' + data.index + '.variable.sku')">
                                <b-form-input 
                                    :id="'sku' + data.index"
                                    type="text"
                                    v-model="data.item.sku"
                                    :formatter="skuFormatter"
                                    :disabled="origin == 'edit_product' && data.item.action !== 'create'"
                                    required>
                                </b-form-input>
                            </b-form-group>
                        </div>
                    </template>
                    <!-- <template slot="on_sale" slot-scope="data">
                        <div style="width: 462px; margin-top: -3px;" class="d-inline-flex align-items-start">
                            <div class="d-inline-block">
                                <switches 
                                    v-model="data.item.on_sale"
                                    theme="custom"
                                    color="primary"
                                    type-bold="true"
                                    style="top: 17px;"
                                    @input="inSaleChecker(data.index)">
                                </switches>
                            </div>
                            <div class="d-inline-block pl-2">
                                <b-form-group
                                    id="allDiscountGroup"
                                    label-for="discount"
                                    class="secondary-label mb-0"
                                    :invalid-feedback="errorMessage('product_variables.' + data.index + '.variable.discount_value')"
                                    :state="isValid('product_variables.' + data.index + '.variable.discount_value')">
                                    <b-input-group>
                                        <b-form-select 
                                            slot="prepend"
                                            :options="options.discount"
                                            v-model="data.item.discount_type"
                                            @input="inDiscountChecker(data.index)">
                                        </b-form-select>
                                        <b-form-input 
                                            id="discountValue"
                                            v-model="data.item.discount_value"
                                            :ref="'discount-value-' + data.index"
                                            required
                                            type="number"
                                            min="1"
                                            @keyup.native="setDiscount({
                                                index: data.index,
                                                base: 'discount_value'
                                            })" />
                                    </b-input-group>
                                </b-form-group>
                            </div>
                            <div class="d-inline-block pl-2">
                                <div style="width: 250px;">
                                    <b-form-group
                                        class="mb-0"
                                        :invalid-feedback="errorMessage('product_variables.' + data.index + '.variable.on_sale_to')"
                                        :state="isValid('product_variables.' + data.index + '.variable.on_sale_to')">
                                        <b-input-group style="top: 1px;">
                                            <b-input-group slot="append">
                                                <i class="icon-calendar"></i>
                                            </b-input-group>
                                            <datepicker
                                                v-model="data.item.date_range"
                                                :config="dateRangeConfig">
                                            </datepicker>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template slot="visibility" slot-scope="data">
                        <switches 
                            v-model="data.item.visibility"
                            theme="custom"
                            color="primary"
                            type-bold="true"
                            style="top: 11px;">
                        </switches>
                    </template> -->
                </b-table>
            </section>
            <section class="py-4 mb-4" v-else-if="origin === 'edit_product'" v-for="(value, index) in values"
                    :key="index">
                <div 
                    v-b-toggle="'product-collapse' + index" 
                    class="border-bottom px-4" 
                    id="collapse-container"
                >
                    <h5 class="variable">
                        {{
                            origin == 'edit_product' && value.variation_code != null
                                ? transformVariationName(value.variation_code)
                                : value.variation
                        }}
                    </h5>
                    <img
                        src="@/assets/images/icons/collapse.svg"
                        alt="Collapsed Icon"
                        class="d-inline-block mr-3 when-closed"
                        style="width: 14px; height: 14px;"
                    />
                    <img
                        src="@/assets/images/icons/expand.svg"
                        alt="Expand Icon"
                        class="d-inline-block mr-3 when-opened"
                        style="width: 14px; height: 14px;"
                    />     
                </div>
                <b-collapse :id="'product-collapse' + index" visible class="py-0 px-4" v-bind:class="{ 'pt-4': !editingFromLocationsPage }">
                    <b-row no-gutters v-if="editingFromLocationsPage">
                        <b-col cols="2">
                            <switches 
                                v-model="value.on_sale"
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                label="Item on Sale"
                                id="sale_switch">
                            </switches>
                        </b-col>
                        <b-col cols="2" class="pl-2">
                            <switches 
                                v-model="value.visibility"
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                label="Visibility"
                                id="visibility_switch">
                            </switches>
                        </b-col>
                        <b-col cols="2" class="pl-2">
                            <switches 
                                v-model="value.is_limited_stock"
                                theme="custom"
                                color="primary"
                                type-bold="true"
                                label="Stock Quantity"
                                id="visibility_switch">
                            </switches>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <div id="regular-price-container">
                                <b-form-group
                                    id="currencyGroup"
                                    label="Regular Price"
                                    label-for="currency"
                                    class="secondary-label"
                                    :invalid-feedback="errorMessage('product_variables.' + index + '.variable.regular_price')"
                                    :state="isValid('product_variables.' + index + '.variable.regular_price')">
                                    <b-input-group>
                                        <b-form-select
                                            slot="prepend"
                                            :options="options.currency"
                                            v-model="value.currency">
                                        </b-form-select>
                                        <b-form-input 
                                            id="regularPrice"
                                            v-model="value.regular_price"
                                            required
                                            type="number"
                                            min="1"
                                            max="10000000000"
                                            oninput="this.value = Math.abs(this.value)" />
                                    </b-input-group>
                                </b-form-group>
                            </div>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group
                                id="skuGroup"
                                label="SKU"
                                label-for="sku"
                                class="secondary-label mb-2"
                                :invalid-feedback="errorMessage('product_variables.' + index + '.variable.sku')"
                                :state="isValid('product_variables.' + index + '.variable.sku')">
                                <b-form-input
                                    :id="'sku' + index"
                                    type="text"
                                    v-model="value.sku"
                                    :disabled="editingFromLocationsPage"
                                    required
                                    :formatter="skuFormatter"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2" v-if="editingFromLocationsPage">
                            <b-form-group
                                id="stockGroup"
                                label="Stock"
                                label-for="stock"
                                class="secondary-label"
                                :invalid-feedback="errorMessage('product_variables.' + index + '.variable.stock')"
                                :state="isValid('product_variables.' + index + '.variable.stock')">
                                <b-form-input
                                    id="duration"
                                    type="number"
                                    :disabled="!value.is_limited_stock"
                                    v-model="value.stock"
                                    required min="0"
                                    oninput="this.value = Math.abs(this.value)">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row v-if="value.on_sale" class="pt-2">
                        <b-col>
                            <div style="width: 462px; margin-top: -3px;" class="d-inline-flex align-items-start">
                                <div class="d-inline-block">
                                    <b-form-group
                                        id="allDiscountGroup"
                                        label-for="discount"
                                        class="secondary-label mb-0"
                                        :invalid-feedback="errorMessage('product_variables.' + index + '.variable.discount_value')"
                                        :state="isValid('product_variables.' + index + '.variable.discount_value')">
                                        <b-input-group>
                                            <b-form-select 
                                                slot="prepend"
                                                :options="options.discount"
                                                v-model="value.discount_type"
                                                @input="inDiscountChecker(index)">
                                            </b-form-select>
                                            <b-form-input 
                                                id="discountValue"
                                                v-model="value.discount_value"
                                                :ref="'discount-value-' + index"
                                                required
                                                type="number"
                                                min="1"
                                                @keyup.native="setDiscount({
                                                    index: index,
                                                    base: 'discount_value'
                                                })" />
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="d-inline-block pl-2">
                                    <div style="width: 250px;">
                                        <b-form-group
                                            class="mb-0"
                                            :invalid-feedback="errorMessage('product_variables.' + index + '.variable.on_sale_to')"
                                            :state="isValid('product_variables.' +index + '.variable.on_sale_to')">
                                            <b-input-group style="top: 1px;">
                                                <b-input-group slot="append">
                                                    <i class="icon-calendar"></i>
                                                </b-input-group>
                                                <datepicker
                                                    v-model="value.date_range"
                                                    :config="dateRangeConfig">
                                                </datepicker>
                                            </b-input-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-collapse>
            </section>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";

export default {
    name: "ProductVariables",
    props: [
        "values",
        "discount",
        "sale",
        "origin",
        "variation_names",
        "payment",
        "basic_details"
    ],
    components: {
        Switches,
        Datepicker
    },
    data() {
        return {
            fields: [
                {
                    key: "variation"
                },
                // {
                //     key: "stock",
                //     thStyle: {
                //         "min-width": "150px"
                //     }
                // },
                {
                    key: "regular_price"
                },
                {
                    key: "sku",
                    label: "SKU"
                }
                // {
                //     key: "on_sale",
                //     label: "Item on Sale"
                // },
                // {
                //     key: "visibility"
                // }
            ],
            options: {
                currency: [{ value: "PHP", text: "PHP" }],
                discount: [
                    { value: "%", text: "%" },
                    { value: "PHP", text: "PHP" }
                ]
            }
        };
    },
    computed: {
        ...mapState("estoreInventories", ["loading", "errors", "product_data"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"]),
        dateRangeConfig: {
            get: function() {
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    // minDate: "today",
                    defaultDate: ["today", "today"]
                };
            }
        }
    },
    methods: {
        skuFormatter: function(value, event) {
            return event === null ? value : value.replace(/[^\w-]/gi, "");
        },
        errorMessage: function(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },
        isValid: function(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },
        discountFormatter: function(value, event) {
            if (event === null) {
                return value;
            }

            if (this.discount.discount_type === "%") {
                if (Number(value) > 99) {
                    return 99;
                }
            }
            return value;
        },
        setDiscount: function(obj) {
            this.$parent.$parent.$parent.setDiscount(obj);
        },
        inDiscountChecker: function(index) {
            this.$parent.$parent.$parent.inDiscountChecker(index);
        },
        inSaleChecker: function(index) {
            this.$parent.$parent.$parent.inSaleChecker(index);
        },
        transformVariationName: function(code) {
            let store_code2 = code.split("_");

            // console.log(store_code2);

            let attributes2 = this.product_data.attributes;

            // console.log(attributes2);
            let variations2 = store_code2
                .map((code, index) => {
                    // console.log(attributes2[index].variations);
                    return attributes2[index].variations
                        .map(item => item)
                        .filter(item => item.hash == code);
                })
                .map(variant => {
                    // console.log(variant[0].name);
                    return variant[0].name;
                });

            // console.log(variations2);

            return variations2.join(" - ");

            // let store_code = code.split("_").map(code => {
            //     return code.split("-")[0];
            // });

            // let attributes = this.product_data.attributes;
            // let variations = store_code
            //     .map((code, index) => {
            //         return attributes[index].variations
            //             .map(item => item)
            //             .filter(item => item.hash.split("-")[0] == code);
            //     })
            //     .map(variant => {
            //         return variant[0].name;
            //     });
            // return variations.join(" - ");
        }
    }
};
</script>

<style lang="scss" scoped>
#collapse-container {
    cursor: pointer;
    display: flex;

    .variable {
        flex: 1;
    }
    // Changed
}
</style>
